module.exports = __webpack_public_path__ + "assets/img/GENERAL_END_PLUGIN.ee235749.svg";